"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntryHandlerKeyword_1 = require("./EntryHandlerKeyword");
/**
 * Handles @context entries.
 */


var EntryHandlerKeywordContext =
/*#__PURE__*/
function (_EntryHandlerKeyword_) {
  _inherits(EntryHandlerKeywordContext, _EntryHandlerKeyword_);

  function EntryHandlerKeywordContext() {
    _classCallCheck(this, EntryHandlerKeywordContext);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntryHandlerKeywordContext).call(this, '@context'));
  }

  _createClass(EntryHandlerKeywordContext, [{
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(parsingContext, util, key, keys, value, depth) {
        var parentContext, context;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Error if an out-of-order context was found when support is not enabled.
                if (!parsingContext.allowOutOfOrderContext && parsingContext.processingStack[depth]) {
                  parsingContext.emitError(new Error('Found an out-of-order context, while support is not enabled.' + '(enable with `allowOutOfOrderContext`)'));
                } // Find the parent context to inherit from


                parentContext = parsingContext.getContext(keys.slice(0, -1)); // Set the context for this scope

                _context.t0 = parsingContext.contextParser;
                _context.t1 = value;
                _context.t2 = parsingContext.baseIRI;
                _context.next = 7;
                return parentContext;

              case 7:
                _context.t3 = _context.sent;
                _context.t4 = {
                  baseIri: _context.t2,
                  parentContext: _context.t3
                };
                context = _context.t0.parse.call(_context.t0, _context.t1, _context.t4);
                parsingContext.contextTree.setContext(keys.slice(0, -1), context);
                parsingContext.emitContext(value);
                _context.t5 = parsingContext;
                _context.next = 15;
                return context;

              case 15:
                _context.t6 = _context.sent;
                _context.next = 18;
                return _context.t5.validateContext.call(_context.t5, _context.t6);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function handle(_x, _x2, _x3, _x4, _x5, _x6) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }]);

  return EntryHandlerKeywordContext;
}(EntryHandlerKeyword_1.EntryHandlerKeyword);

exports.EntryHandlerKeywordContext = EntryHandlerKeywordContext;